/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import BaseIdObject from "@shared/BaseIdObject";
import {Type} from "@qwoach/class-transformer-wrapper";
import TagItem from "@shared/Tags/TagItem";
import {isObject} from "@/utils/helpers";
import {SessionPlanItemTypeEnum} from "@shared/Journal/SessionPlanItemTypeEnum";
import {SessionPlanRollForwardEnum} from "@shared/Journal/SessionPlanRollForwardEnum";

export default class SessionPlanItem extends BaseIdObject {
	title: string = null
	description: string = null
	content: string = null
	itemType: string = SessionPlanItemTypeEnum.TEXT
	sortIndex: number = 0
	rollForward: string = SessionPlanRollForwardEnum.NONE
	isReadonly: boolean = false
	defaultTagColor: string = null

	@Type(() => TagItem)
	tags: TagItem[] = []

	constructor(options = {}) {
		super(options)
		this.applyOptions(options)
		if(Array.isArray(options.tags)){
			this.tags = options.tags.map(item => item instanceof TagItem ? item : new TagItem(item))
		}
	}

	addTag(item){
		if(isObject(item)){
			this.tags.push(new TagItem({...item, color: item.color || this.defaultTagColor}))
		}
	}

	hasContent(){
		return !!String(this.content || "").trim() || (this.tags || []).length > 0
	}

	isLibraryItem(){
		return this.itemType === SessionPlanItemTypeEnum.TAGS
	}

	contentToString(){
		switch (this.itemType) {
			case SessionPlanItemTypeEnum.TAGS:
				return this.tags.map(t => t.title).join(', ')
			default:
				return this.content
		}
	}
}
